import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from './services/userService';

@NgModule({
  imports: [CommonModule],
  providers: [UserService],
})
export class KeyingUserModule {}
